import React from "react";
import UseCaseHeader from "components/UseCaseHeader";
import ServiceIconGrid from "components/ServiceIconGrid";
import { USE_CASES } from "utils/constants/useCases";
import IMAGES from "utils/constants/image";
import { SOCIAL_SERVICE } from "utils/constants/useCases";
import { styles } from "./styles";

const COPY_PRIMARY =
  "Payment links help companies chat and transact with the global market of over 5 bn people who are using messengers monthly.";
const COPY_SECONDARY =
  "Payment links provide an efficient and low friction way for customers to complete a transaction directly from their conversations.";

const Social = () => {
  const compatibleWith = (
    <div className="w-100 pt3">
      <div className="f6 black-50 pb2 pb0-l">Compatible with</div>
      <ServiceIconGrid
        services={[
          SOCIAL_SERVICE.WHATSAPP,
          SOCIAL_SERVICE.WECHAT,
          SOCIAL_SERVICE.MESSENGER,
          SOCIAL_SERVICE.INSTAGRAM,
          SOCIAL_SERVICE.SNAPCHAT,
          SOCIAL_SERVICE.TWITTER,
          SOCIAL_SERVICE.MESSENGER
        ]}
      />
    </div>
  );
  return (
    <section className="w-100">
      <div className="w-100 w-50-ns fr relative">
        <UseCaseHeader type={USE_CASES.SOCIAL} />
        <div className="f5 f4-l tl lh-copy pt2 pt4-l">
          {COPY_PRIMARY}
          <sup className="f7">[4]</sup>
        </div>
        <div className="dn dib-ns">
          <div className="f5 f4-l mb3 mt0-ns tl lh-copy pt2">
            {COPY_SECONDARY}
          </div>
          {compatibleWith}
        </div>
      </div>
      <div className="w-100 w-50-ns fr pt3 pt0-l">
        <div className={`${IMAGES.USE_CASE_SOCIAL}--wrapper`}>
          <div className={`${IMAGES.USE_CASE_SOCIAL}--img contain contain`} />
        </div>
        <div className="w-100 dn-ns dib">
          <div className="f5 f4-l fw4 mb3 mt3 mt0-ns tl lh-copy pt2">
            {COPY_SECONDARY}
          </div>
          {compatibleWith}
        </div>
      </div>
      <style jsx>{styles}</style>
    </section>
  );
};

export default Social;
